import React from 'react';

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import MuiTextField, { StandardTextFieldProps } from '@material-ui/core/TextField';
import classnames from 'classnames';
import { get } from 'lodash';

const styles = (theme: Theme) =>
  createStyles({
    input: {
      color: theme.custom.palette.colorSupportMidnight,
    },
    inputSmall: {
      height: '35px !important',
    },
    rounded: {
      borderRadius: 5,
    },
    rootReadOnly: {
      border: 'none',
    },
    disabled: {
      border: `1px solid ${grey[300]}`,
    },
    // NOTE [class below]: fixedWidth is used when an input of type number has a `max` attribute because chrome
    //      automatically adjusts the width of the input ref: https://stackoverflow.com/questions/22590483/
    //      why-does-adding-min-max-properties-change-the-width-of-a-numeric-html5-input-ele
    fixedWidth: {
      width: 149,
    },
  });

export interface TextFieldProps extends Omit<StandardTextFieldProps, 'classes'>, WithStyles<typeof styles> {
  size?: 'default' | 'small';
  rounded?: boolean;
}

const TextFieldSearchComponent: React.FC<TextFieldProps> = ({
  classes,
  size = 'default',
  rounded,
  InputProps,
  ...rest
}) => (
  <MuiTextField
    InputProps={{
      ...InputProps,
      classes: {
        root: classnames(get(InputProps, 'classes.root'), {
          [classes.rounded]: rounded,
          [classes.rootReadOnly]: get(rest.inputProps, 'readOnly'),
          [classes.disabled]: rest.disabled,
        }),
        input: classnames(get(InputProps, 'classes.input'), {
          [classes.inputSmall]: size === 'small',
          [classes.rounded]: rounded,
          [classes.fixedWidth]: get(rest, 'inputProps.max'),
        }),
      },
    }}
    {...rest}
  />
);

export const TextField = withStyles(styles)(TextFieldSearchComponent);
